import { useState, useEffect } from "react";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Switch from "@mui/material/Switch";

// Material Dashboard 3 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";

import axios from "api/baseurl";

// Encryption and Decryption Functions
import { encryptBody } from "encryptionAndDecryption/bodyEncryption";
import { decryptBody } from "encryptionAndDecryption/bodyDecryption";
import { fetchSecretKey } from "encryptionAndDecryption/secretKeyDecryption";

function Header() {
  const [visible, setVisible] = useState(true);
  const [userData, setUserData] = useState(null);
  const [secretKey, setSecretKey] = useState("");

  const handleSetVisible = () => setVisible(!visible);

  useEffect(() => {
    const fetchUserBio = async () => {
      try {
        const key = await fetchSecretKey();
        setSecretKey(key);

        const encryptedRequest = encryptBody({}, key);

        const response = await axios.post("/api/account-bio", 
          { data: encryptedRequest },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );

       
        const decryptedData = decryptBody(response.data, key);
        setUserData(decryptedData);
      } catch (error) {
        console.error("Error fetching user bio:", error);
      }
    };

    fetchUserBio();
  }, []);

  return (
    <Card id="profile">
      <MDBox p={2}>
        <Grid container spacing={3} alignItems="center">
          <Grid item>
            <MDAvatar
              src={userData?.profileImage}
              alt="profile-image"
              size="xl"
              shadow="sm"
            />
          </Grid>
          <Grid item>
            <MDBox height="100%" mt={0.5} lineHeight={1}>
              <MDTypography variant="h5" fontWeight="medium">
                {userData?.name || "User Name"}
              </MDTypography>
              <MDTypography variant="button" color="text" fontWeight="medium">
                {userData?.designation || "User Role"}
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={3} sx={{ ml: "auto" }}>
            <MDBox display="flex" justifyContent={{ md: "flex-end" }} alignItems="center" lineHeight={1}>
              <MDTypography variant="caption" fontWeight="regular">
                Switch to {visible ? "invisible" : "visible"}
              </MDTypography>
              <MDBox ml={1}>
                <Switch checked={visible} onChange={handleSetVisible} />
              </MDBox>
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>
    </Card>
  );
}

export default Header;

